import {Methods} from "@newview/infrastructure";
import {SmartSiteBaseApiV2} from "../SmartSiteBaseApiV2";
/**
 * 知识分类
 */
export class PersonResumeInfoApi extends SmartSiteBaseApiV2 {

    public get ControllerName(): any {
        return 'personResumeInfo';
    }


    public  getTitleList(data) {
        return this.send(data,"getTitleList",Methods.GET)
    }

    public getStaffList(BIId,personType,userName){
      return this.send({BIId:BIId,personType:personType,userName:userName},"getStaffList",Methods.GET)
    }

    public saveInfo(data){
        return this.send(data,"saveInfo",Methods.POST)
    }
    
}